exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".expansion__content[data-v-44e020f9]{max-height:calc(100vh - 260px);padding:0 10px;overflow:hidden}\n", ""]);
